import { Button } from '@montel/montelpro-shared-components-v2';
import { createColumnHelper } from '@tanstack/react-table';
import { ButtonContainer } from 'components/common/Product/Cells/styles';
import { HeadCell, SortableHeadCell, TextCell } from 'components/tables/cells';
import { Company } from 'domain/company/Company';

const columnHelper = createColumnHelper<Company>();

const getColor = (addedCompanies: Company[] | undefined, companyId: number) =>
	addedCompanies?.some((c) => c.id == companyId) ? 'bgSuccess' : undefined;

export const providerBlacklistTableColumns = {
	name: (addedCompanies?: Company[]) =>
		columnHelper.accessor((row) => row.name, {
			id: 'name',
			enableSorting:
				addedCompanies && addedCompanies.length > 0 ? false : true,
			size: 100,
			header: ({ header }) => (
				<SortableHeadCell text="Name" header={header} />
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					color={getColor(addedCompanies, info.row.original.id)}
				/>
			),
		}),
	youniumAccountNumber: (addedCompanies?: Company[]) =>
		columnHelper.accessor((row) => row.youniumAccountNumber, {
			id: 'youniumAccountNumber',
			enableSorting:
				addedCompanies && addedCompanies.length > 0 ? false : true,
			header: ({ header }) => (
				<SortableHeadCell
					text="Younium Account Number"
					header={header}
				/>
			),
			cell: (info) => (
				<TextCell
					text={info.getValue()}
					color={getColor(addedCompanies, info.row.original.id)}
				/>
			),
		}),
	actions: (removeCompany: (company: Company) => void, disabled?: boolean) =>
		columnHelper.accessor(() => null, {
			id: 'actions',
			enableSorting: false,
			meta: { width: '120px' },
			header: () => <HeadCell text="" />,
			cell: (info) => (
				<ButtonContainer>
					<Button
						size="sm"
						text={'Remove company'}
						type="button"
						variant={'secondary'}
						isDisabled={disabled}
						onClick={(e) => {
							e.stopPropagation();
							removeCompany(info.row.original);
						}}
					/>
				</ButtonContainer>
			),
		}),
};
